import { Location, NgClass } from "@angular/common";
import { Component, HostListener, OnInit, Renderer2, ViewChild } from "@angular/core";
import { doc, Firestore, getDoc } from "@angular/fire/firestore";
import { FormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { LoadingService } from "@core/loading.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, throwError } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { LoginDataResolverService } from "src/app/services/login-data-resolver.service";
import { PaymentService } from "src/app/services/payment.service";
import { DisplayCurrencyPipe } from "../../../pipe/display-currency.pipe";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";
import { StoreRepositoryService } from "../../store/store-repository.service";
import { SyndicateRepositoryService } from "../../syndicate/syndicate-repository.service";
import { NoThanksPopupComponent } from "../no-thanks-popup/no-thanks-popup.component";
import { ToastFacadeService } from "@core/toast-facade.service";
declare var window;
@Component({
  selector: "app-free-reg-step4g",
  templateUrl: "./free-reg-step4g.component.html",
  styleUrls: ["./free-reg-step4g.component.scss", "../onesignal.scss"],
  standalone: true,
  imports: [
    IonicModule,
    NgClass,
    FormsModule,
    DisplayCurrencyPipe,
    SafeHtmlPipe,
    TranslatePipe],
})
export class FreeRegStep4gComponent implements OnInit {
  jackpotTrigger;
  storedCards = [];
  count: any = 0;
  isPaymentDone: boolean = false;
  paymentReceived: any;
  payment_status: any;
  isPaymill: any = false;
  productDetails: any;
  loaded: boolean;
  modalCtrl: any;
  jackpots;
  purchaseDetail: any;
  paymentProsubId: any;
  insertCustomerPurchaseRes: any;
  responseObject: any;
  selectedCard: any = "10";
  addNewCardInProgress: boolean = false;
  addingCard: boolean;
  pathString: any;
  offer: any;
  isPaymenthide = true;
  userProduct$ = new BehaviorSubject<any>({});
  userProduct: any;
  prosub_id: any;
  qParams: any;
  paymentPageData: any;
  selectedLanguage: string;
  prize: any;
  isOnline: boolean = true;
  translatedToastMsg: any;
  origin = window.location.origin;
  timerOn = true;
  timeOut: boolean;
  minutes: number;
  @ViewChild("timer", { static: false }) timerspan: Data;
  public TP1: string = window.localStorage.getItem("TP1");
  public Tp2: string = window.localStorage.getItem("TP2");
  public TP3: string = window.localStorage.getItem("TP3");
  public T_ID: string = window.localStorage.getItem("T_ID");
  public Prosub_id: any = window.localStorage.getItem("prosub_id");
  userId: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private syndicateService: SyndicateRepositoryService,
    private location: Location,
    public translate: TranslateService,
    private authService: AuthService,
    private snackService: MySnackBarService,
    private router: Router,
    private paymentService: PaymentService,
    public GTMservice: GTMSegmentService,
    private firestore: Firestore,
    private utilityService: UtilityService,
    private storeService: StoreRepositoryService,
    private loadingService: LoadingService,
    private matDialog: MatDialog,
    private loginData: LoginDataResolverService,
    private AuthPartialRegService: AuthPartialRegService,
    private renderer: Renderer2,
    private toastFacade: ToastFacadeService
  ) {
    this.minutes = 600;
    localStorage.removeItem("d");
    this.loaded = false;
    this.userProduct = this.loginData.userProduct$.value;
    this.qParams = this.GTMservice.userProduct$.value;
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.callSigUpForSalesResponse$.subscribe((d) => {
      if (d && window.location.href.search("free-reg-step4g") > -1) {
        if (d && d?.response?.status === "FAIL") {
          this.authService.callSigUpForSalesResponse$.next(null);
          const proSub = localStorage.getItem("prosub_id");
          this.authService.logout().then();
          if (proSub === null) return;
          this.router.navigateByUrl(`partial-registration?prosub_id=${proSub}`);
          if (d?.response?.message === "MSN_INVALID") {
            const message = "Registration failed, please enter a correct phone number.";
            this.authService.showAnonymousUserMessage(message);
            return;
          }
          this.authService.showAnonymousUserMessage();
        }
      }
    });

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  @HostListener("window:message", ["$event"])
  onMessage(e): void {
    if (e && e?.data && e?.data?.for === "paymentDone") {
      this.afterNewCardPaymentDone();
    }
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("FreeRegStep4gComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });

    Network.addListener("networkStatusChange", (e) => {
      try {
        if (e.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        return error;
      }
    });

    this.loadingService.present();
    this.jackpotTrigger = {
      offer_link_id: this.userProduct?.prosub_id,
      offer_id: this.userProduct?.offer_id,
      free_jackpot: this.userProduct?.free_jackpot ?? false,
      alternate_free_jackpot: this.userProduct?.alternate_free_jackpot ?? false,
      free_offer_id: this.userProduct?.free_offer_id ?? 0,
    };
    localStorage.setItem("free_reg_journey", "free-reg-step4g");

    this.activatedRoute.queryParams.subscribe(
      (data: any) => {
        this.prosub_id = data?.Prosub_ID ? data?.Prosub_ID : data?.prosub_id;
        if (this.prosub_id) {
          this.AuthPartialRegService.partial_Reg(this.prosub_id, "", "").subscribe((r) => {
            this.paymentPageData = r.paymentHtml;
            this.loaded = true;
            this.loadingService.dismiss();
          });
        }
        if (data && data?.prosub_id) {
          this.jackpotTrigger.offer_link_id = data?.prosub_id;
        }
        if (data && data?.offer_id) {
          this.jackpotTrigger.offer_id = data?.offer_id;
        }
      },
      (err) => {
        this.loadingService.dismiss();
        return err;
      }
    );

    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.productDetails = params;
      this.loaded = true;
    });
  }

  async callInt2() {
    await this.paymentService.getOptionalPage("").then(async (resp) => {
      const post_name = resp;
      if (post_name === "free-reg-complete-profile") {
        try {
          this.authService.userDetails$.pipe(take(1)).subscribe(
            (user: any) => {
              if (user?.minimal_required == true) {
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4g";
                this.paymentService.freeRegJourneySuccessURL = "mainTabs/tabs/syndicate?trigger=activated";
                this.router.navigateByUrl(`${this.paymentService.freeRegJourneySuccessURL}`);
              } else {
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4g";
                this.userProduct$.next(this.loginData.userProduct$.value);
                this.paymentService.freeRegJourneySuccessURL = post_name;
                this.router.navigateByUrl(
                  `${post_name +
                  "?prosub_id=" +
                  this.Prosub_id +
                  "&" +
                  "TP1=" +
                  this.TP1 +
                  "&" +
                  "TP2=" +
                  this.Tp2 +
                  "&" +
                  "TP3=" +
                  this.TP3 +
                  "&" +
                  "T_ID=" +
                  this.T_ID
                  }`
                );
              }
            },
            (err) => {
              //this.snackService.openSnackBar("Something went wrong (user)", "", "custom-class-fail", "Error");
              /* const msg = this.translatedToastMsg?.["1013"]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : "Something went wrong (user)", "Error", ""); */
              this.authService.getConstantsMsg("1013").then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong (user)",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
            }
          );
        } catch (error) {
          //this.snackService.openSnackBar("Something went wrong", "", "custom-class-fail", "Error");
          /* const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "Something went wrong", "Error", ""); */
          this.authService.getConstantsMsg("1014").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
        }
      } else {
        this.router.navigateByUrl(`${post_name}`);
      }
    });
  }
  async activateTrigger() {
    this.GTMservice.HotJarEvent("user_activate_trigger");
    if (!window.navigator.onLine) return;
    this.syndicateService
      .activateTrigger(this.jackpotTrigger)
      .pipe(
        catchError((error) => {
          // RB #24242 fix
          return throwError(error);
        })
      )
      .subscribe(
        async (res: any) => {
          if (res?.status === "rejected") {
            this.authService
              .getConstantsMsg(res?.error_code)
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                return error;
              });
            return;
          }
          this.loadingService.dismiss();
          if (res?.status === "fail") {
            //this.snackService.openSnackBar(res.message ? res.message : "Process failed", "", "Error", "Error");
            /* const msg = this.translatedToastMsg?.["1056"]?.[this.selectedLanguage];
          this.authService.showToast(res.message ? res.message : msg ? msg : "Process failed", "Error", ""); */
            this.authService
              .getConstantsMsg("1056")
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Process failed",
                    line_2: "",
                  },
                  style: {
                    type: "Error",
                    icon: "tick circle error.svg",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                return error;
              });
            this.isPaymenthide = true;
          } else {
            this.callInt2();
            /* this.snackService.openSnackBar(
            res.message ? res.message : "Trigger On! Control your trigger here",
            "",
            "custom-class-trigger",
            "Success"
          ); */ //move the snackbar to syndicate  page
            /*  const msg = this.translatedToastMsg?.["1047"]?.[this.selectedLanguage];
           this.authService.showToast(
             res.message ? res.message : msg ? msg : "Trigger On! Control your trigger here",
             "Success",
             ""
           ); */
            // this.authService.getConstantsMsg("1047").then((translatedMsg) => {
            //   const defaultMsg = {
            //     message: {
            //       line_1: "Trigger On! Control your trigger here",
            //       line_2: "",
            //     },
            //     style: {
            //       type: "Success",
            //       icon: "tick circle success.png",
            //     },
            //   };
            //   this.authService.showToastMessage(translatedMsg, defaultMsg);
            // });
          }
        },
        (err) => {
          this.loadingService.dismiss();
          return err;
        }
      );
  }
  activateTriggerBtn() {
    this.loadingService.present();
    this.authService.userDetails$.pipe(take(1)).subscribe(
      (user: any) => {
        if (user?.token_exists) {
          this.activateTrigger();
        } else {
          const systemReferenceDocRef = doc(this.firestore, "general_modules/system_reference");

          getDoc(systemReferenceDocRef)
            .then((r: any) => {
              const preAuthOffer = r?.data();

              this.paymentService
                .insertCustomerPurchase(
                  {
                    offer_id: preAuthOffer?.pre_auth_offer_id,
                    offers: { price: preAuthOffer?.pre_auth_amount },
                  },
                  "/api_post_request/insert_customer_purchase_4g"
                )
                .subscribe((result: any) => {
                  this.loadingService.dismiss();
                  if (result?.status === "rejected") {
                    this.authService
                      .getConstantsMsg(result?.error_code)
                      .then((translatedMsg) => {
                        const defaultMsg = {
                          message: {
                            line_1: "Something went wrong!",
                            line_2: "",
                          },
                          style: {
                            icon: "tick circle error.svg",
                            type: "Error",
                          },
                        };
                        this.authService.showToastMessage(translatedMsg, defaultMsg);
                      })
                      .catch((err) => {
                        return err;
                      });
                    return;
                  }
                  if (result?.response && result?.response?.status === "SUCCESS") {
                    this.insertCustomerPurchaseRes = result;
                    this.purchaseDetail = result;
                    this.purchaseDetail["offer_id"] = preAuthOffer?.pre_auth_offer_id;
                    this.purchaseDetail["price"] = preAuthOffer?.pre_auth_amount;
                    this.loaded = true;
                    this.timer(this.minutes);
                    const paymentReason = "offer";
                    this.paymentService
                      .getCheckoutId(preAuthOffer?.pre_auth_amount, "GBP", {}, paymentReason)
                      .subscribe(async (data) => {
                        if (data?.id) {
                          this.isPaymill = true;
                          try {
                            // Logic to unload the existing widget
                            await this.unloadPaymentWidget();
                          } catch (error) {
                            return error;
                          }
                          this.utilityService.loadScriptForPayment([data?.paymentWidgetUrl]);
                          this.pathString = String(data?.id);
                          this.isPaymenthide = false;
                        }
                      });
                  }
                });
            })
            .catch((err) => {
              this.loadingService.dismiss();
              console.error("Error fetching system reference:", err);
            });
        }
      },
      (err) => {
        this.authService.getConstantsMsg("1013").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong (user)",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        });
      }
    );
  }
  navigateToRegistrationDefault() {
    this.location.back();
  }

  getCheckCardDetailId() {
    if (!this.storedCards) return;
    return this.storedCards?.find((x) => x?.isChecked);
  }

  load(e) {
    this.count++;
    if (this.count > 2) {
      this.isPaymentDone = true;
    }
  }

  private afterNewCardPaymentDone(): void {
    if (!this.paymentReceived && localStorage.getItem("d")) {
      this.paymentReceived = true;
      let urlData;
      if (
        localStorage.getItem("d") != "" &&
        localStorage.getItem("d") != null &&
        localStorage.getItem("d") != undefined
      ) {
        urlData = JSON.parse(localStorage.getItem("d"));
      }
      setTimeout(() => {
        const path_id = "At4Vyy58QQ2vknYAhw7T";
        const doc_data = {
          payment_response_checkout: {
            id: urlData?.id,
            respource_url: urlData?.resourcePath,
            cehckout_done_at: new Date(),
          },
        };
        const dv = { docId: this.pathString };
        const method = "update";

        this.authService.getV2CloudFunction("updatefirestoredoc", {
          path_id,
          doc_data,
          dv,
          method,
        }).subscribe({
          error: (err) => {
            console.error('Error updating payment response checkout:', err);
          }
        });

        // Check payment status
        this.paymentService
          .checkPaymentStatus(urlData?.id)
          .pipe(take(1))
          .subscribe(
            (payment_status) => {
              this.payment_status = payment_status;

              if (
                payment_status?.result?.description.search("succeeded") > -1 ||
                payment_status?.response?.status !== "SUCCESS"
              ) {
                this.isPaymentDone = false;

                const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
                const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
                this.toastFacade.showByCode(toastCode, fallback, {
                  journey: "payment",
                  trigger: "manual_login_payment_result",
                  reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
                });

                // Update the payment response in Firestore
                  const path_id = "At4Vyy58QQ2vknYAhw7T";
                  const doc_data = { payment_response: payment_status };
                  const dv = {docId: this.pathString};
                  const method = "update";

                this.authService.getV2CloudFunction("updatefirestoredoc", {
                  path_id,
                  doc_data,
                  dv,
                  method,
                }).subscribe({
                  next: () => {
                    this.payment_status = payment_status;
                  },
                  error: (err) => {
                    console.error('Error updating payment response:', err);
                  }
                });

                // Update SQL API with payment request and response
                this.paymentService
                  .updatePaymentReqAndRes(
                    {
                      ...this.purchaseDetail,
                      customer_purchase_id: this.insertCustomerPurchaseRes?.response?.customer_purchase_id,
                    },
                    payment_status,
                    { is_preauth: true }
                  )
                  .subscribe(
                    (sqlAPICall) => {
                      if (sqlAPICall && sqlAPICall?.response?.status !== "SUCCESS") {
                        this.authService.getConstantsMsg("1015").then((translatedMsg) => {
                          const defaultMsg = {
                            message: {
                              line_1: "Something went wrong!",
                              line_2: "",
                            },
                            style: {
                              icon: "tick circle error.svg",
                              type: "Error",
                            },
                          };
                          this.authService.showToastMessage(translatedMsg, defaultMsg);
                        });
                        return;
                      }
                      this.paymentService.emitSyndicatePurchaseComplete();
                      this.paymentService.salesJournyPaymentDetails$.next(sqlAPICall?.response?.encrypt_syndicate_id);
                      this.activateTrigger();
                    },
                    (err) => {
                      console.error("Error updating SQL API:", err);
                      return err;
                    }
                  );

                return;
              } else {
                const toastCode = this.paymentService.mapPaymentToastCode(payment_status);
                const fallback = this.paymentService.mapPaymentToastFallback(payment_status);
                this.toastFacade.showByCode(toastCode, fallback, {
                  journey: "payment",
                  trigger: "manual_login_payment_result",
                  reason_code: this.paymentService.mapPaymentReasonCode(payment_status),
                });
                this.isPaymentDone = false;
                return this.location.back();
              }
            },
            (err) => {
              console.error("Error checking payment status:", err);
              return err;
            }
          );
      }, 1000);
    }
  }
  openNoThanks() {
    const modal = this.matDialog.open(NoThanksPopupComponent, {
      height: "40%",
      width: "80%",
    });
  }
  timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;

    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    // document.getElementById("timer").innerHTML = m + ":" + s;
    if (this.timerspan) {
      this.timerspan.nativeElement.innerHTML = m + ":" + s;
    }
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }
    this.isPaymenthide = true;
    setTimeout(() => {
      this.authService.getConstantsMsg("1100").then();
    }, 1000);
    const defaultMsg = {
      message: {
        line_1: "Session timeout has occur, Please try again!",
        line_2: "",
      },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    this.authService.showToastMessage(null, defaultMsg);

    // Do timeout stuff here
    this.timeOut = true;
    this.addingCard = false;
    this.addNewCardInProgress = false;
  }

  private async unloadPaymentWidget(): Promise<void> {
    try {
      if (window.wpwl !== undefined && window.wpwl?.unload !== undefined) {
        await window.wpwl.unload();

        // Remove scripts using Renderer2
        const scripts = document.querySelectorAll('script[src*="static.min.js"]');
        scripts.forEach(script => {
          this.renderer.removeChild(document.body, script);
        });
      }
    } catch (error) {
      return error; // Rethrow the error for proper handling
    }
  }
}
